import { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { RootState } from '../../store/rootReducer'
import { useSelector } from 'react-redux'

export type HeaderProps = {
    classNameString?: string
}

function Header({ classNameString }: HeaderProps) {
    const { member } = useSelector((state: RootState) => ({
        member: state.member,
    }))

    const [show, setShow] = useState(false)
    const [lastScrollY, setLastScrollY] = useState(0)
    const controlNavbar = useCallback(() => {
        if (window.scrollY > 40) {
            if (window.scrollY > lastScrollY) {
                setShow(true)
            } else {
                setShow(false)
            }
        } else if (window.scrollY <= 40) {
            setShow(false)
        }
        setLastScrollY(window.scrollY)
    }, [lastScrollY])

    // self dotenv
    const [domains, setdomains] = useState('')
    function changeDomains() {
        if (process.env.REACT_APP_NODE_ENV === 'test') {
            setdomains('http://localhost:7556')
        } else if (process.env.REACT_APP_NODE_ENV === 'development') {
            setdomains('https://photo-dev.wjthinkbig.com/')
        } else {
            setdomains('https://pic.wjthinkbig.com/')
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', controlNavbar)
        changeDomains()
        return () => {
            window.removeEventListener('scroll', controlNavbar)
        }
    }, [controlNavbar, lastScrollY])

    return (
        <header className={`header ${show ? 'hidden' : ''}`}>
            <div className={`header__wrap`}>
                <div className="header__inner">
                    {/* <div className="header__buttons">
                        <button type="button">
                            <span className="_hidden">뒤로가기</span>
                        </button>
                    </div> */}

                    <div className="header__logo">
                        <Link
                            to={
                                member.userSeq === undefined
                                    ? '/mobileWjdict'
                                    : `/mobileWjdict/?&userSeq=${member.userSeq}&userName=${member.userName}`
                            }
                        >
                            <span className="_hidden">LOGO</span>
                        </Link>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header
